import ApiService from './api'

/**
 * Leave Types Service
 */
export const leaveTypeService = {
  // Get all leave types
  getAllLeaveTypes: async () => {
    try {
      const response = await ApiService.get('/hr/leave-types')
      return response
    } catch (error) {
      console.error('Error fetching leave types:', error)
      throw error
    }
  },

  // Get leave type by ID
  getLeaveTypeById: async (id) => {
    try {
      const response = await ApiService.get(`/hr/leave-types/${id}`)
      return response
    } catch (error) {
      console.error('Error fetching leave type:', error)
      throw error
    }
  },

  // Create new leave type
  createLeaveType: async (leaveTypeData) => {
    try {
      const response = await ApiService.post('/hr/leave-types', leaveTypeData)
      return response
    } catch (error) {
      console.error('Error creating leave type:', error)
      throw error
    }
  },

  // Update leave type
  updateLeaveType: async (id, leaveTypeData) => {
    try {
      const response = await ApiService.patch(`/hr/leave-types/${id}`, leaveTypeData)
      return response
    } catch (error) {
      console.error('Error updating leave type:', error)
      throw error
    }
  },

  // Delete leave type
  deleteLeaveType: async (id) => {
    try {
      const response = await ApiService.delete(`/hr/leave-types/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting leave type:', error)
      throw error
    }
  }
}

/**
 * Leaves Service
 */
export const leaveService = {
  // Get all leaves with optional filters
  getAllLeaves: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== '')
      ).toString()
      const url = queryString ? `/hr/leaves?${queryString}` : '/hr/leaves'
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      console.error('Error fetching leaves:', error)
      throw error
    }
  },

  // Get leave by ID
  getLeaveById: async (id) => {
    try {
      const response = await ApiService.get(`/hr/leaves/${id}`)
      return response
    } catch (error) {
      console.error('Error fetching leave:', error)
      throw error
    }
  },

  // Create new leave
  createLeave: async (leaveData) => {
    try {
      const response = await ApiService.post('/hr/leaves', leaveData)
      return response
    } catch (error) {
      console.error('Error creating leave:', error)
      throw error
    }
  },

  // Update leave
  updateLeave: async (id, leaveData) => {
    try {
      const response = await ApiService.patch(`/hr/leaves/${id}`, leaveData)
      return response
    } catch (error) {
      console.error('Error updating leave:', error)
      throw error
    }
  },

  // Delete leave
  deleteLeave: async (id) => {
    try {
      const response = await ApiService.delete(`/hr/leaves/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting leave:', error)
      throw error
    }
  }
}

/**
 * Leave Applications Service (For future implementation)
 */
export const leaveApplicationService = {
  // Get all leave applications
  getAllLeaveApplications: async () => {
    try {
      const response = await ApiService.get('/hr/leave-applications')
      return response
    } catch (error) {
      console.error('Error fetching leave applications:', error)
      throw error
    }
  },

  // Get pending leave applications
  getPendingLeaveApplications: async () => {
    try {
      const response = await ApiService.get('/hr/leave-applications?status=pending')
      return response
    } catch (error) {
      console.error('Error fetching pending leave applications:', error)
      throw error
    }
  },

  // Create new leave application
  createLeaveApplication: async (applicationData) => {
    try {
      const response = await ApiService.post('/hr/leave-applications', applicationData)
      return response
    } catch (error) {
      console.error('Error creating leave application:', error)
      throw error
    }
  },

  // Update leave application status
  updateLeaveApplicationStatus: async (id, status, comments = '') => {
    try {
      const response = await ApiService.patch(`/hr/leave-applications/${id}/status`, {
        status,
        comments
      })
      return response
    } catch (error) {
      console.error('Error updating leave application status:', error)
      throw error
    }
  }
}

export default {
  leaveTypeService,
  leaveService,
  leaveApplicationService
}
